import compact from 'lodash/compact'
import map from 'lodash/map'

import { LookDisplayBlock, LookTile, PagePresentation, PageType } from '@Generated/graphql'
import { ImagePin } from '@Globals/Image'

export function getPins(
  data: LookDisplayBlock | LookTile,
  id?: string,
  presentation: PagePresentation = PagePresentation.Full,
): ImagePin[] {
  return compact(map(data.products, (item) => {
    const productID = item?.productID || item?.product?.id
    if (!item?.x || !item?.y || !productID) {
      return null
    }

    return {
      id: data.id || '',
      x: item.x,
      y: item.y,
      type: PageType.Look,
      scrollInToView: `#${presentation === PagePresentation.Sidebar ? `modal_sidebar_pin_product_${productID}` : `${id}_pin_product_${productID}`}`,
    }
  }))
}
